
import useEventTracking from "./tracking"

export const useProductKitDownload = () => {
  const trackEvent = useEventTracking();


  return {
    openDownload: () => { }
  }
}
